<script>
  import { Route, useNavigate } from "svelte-navigator";
  import { useUrlParams } from "@stores/urlStore.js";
  import { DAM_ANALYSIS_SUBROUTES , ROUTES } from "@utils/routes.js";
  import WorkflowExplorer from "./Project/TaskExplorer.svelte";
  import Ngrams from "./analysis/ngrams.svelte";
  import Heatmap from "./analysis/heatmap.svelte";
  import AppConnections from "./analysis/appConnections.svelte";
  import Shortcuts from "./analysis/shortcuts.svelte";
  import AppUsers from "./analysis/workload.svelte";
  import Treemap from "./analysis/treemap.svelte";
  import { SvelteFlowProvider } from "@xyflow/svelte";
  import CaseIdMapper from "./Project/CaseidMapper.svelte";
  import KpiMatrix from "./analysis/KPIMatrix.svelte";
  import ChangeAnalysis from "./analysis/changeAnalysis.svelte";
  import { filtersConfigStore } from "@stores/damFiltersConfigStores.js";

  const urlParams = useUrlParams();
  const navigate = useNavigate();
  const { getFiltersConfig } = filtersConfigStore;
  let redirected = false;

  $: ({ idproject } = $urlParams);
  $: hasRequiredParams = Boolean($urlParams.idproject);
  $: if (!hasRequiredParams && !redirected) {
    redirected = true;
    Promise.resolve(navigate(ROUTES.dam.root, { replace: true })).catch(() => {
      window.location.replace(ROUTES.dam.root);
    });
  }
  $: if (idproject) {
    getFiltersConfig(idproject);
  }

  $$restProps;
</script>
{#if hasRequiredParams}
    <Route path={DAM_ANALYSIS_SUBROUTES.treemap}><Treemap {idproject} /></Route>
    <Route path={DAM_ANALYSIS_SUBROUTES.automation}>
      <SvelteFlowProvider><Ngrams {idproject} /></SvelteFlowProvider>
    </Route>
    <Route path={DAM_ANALYSIS_SUBROUTES.workflow}>
      <SvelteFlowProvider><WorkflowExplorer {idproject} /></SvelteFlowProvider>
    </Route>
    <Route path={DAM_ANALYSIS_SUBROUTES.heatmap}><Heatmap {idproject} /></Route>
    <Route path={DAM_ANALYSIS_SUBROUTES.connections}
      ><AppConnections {idproject} /></Route
    >
    <Route path={DAM_ANALYSIS_SUBROUTES.shortcuts}><Shortcuts {idproject} /></Route
    >
    <Route path={DAM_ANALYSIS_SUBROUTES.copyPaste}
      ><Shortcuts {idproject} /></Route
    >
    <Route path={DAM_ANALYSIS_SUBROUTES.workload}><AppUsers {idproject} /></Route>
    <Route path={DAM_ANALYSIS_SUBROUTES.caseExplorer}
      ><CaseIdMapper {idproject} /></Route
    >
    <Route path={DAM_ANALYSIS_SUBROUTES.kpiMatrix}><KpiMatrix {idproject} /></Route
    >
    <Route path={DAM_ANALYSIS_SUBROUTES.changeAnalysis}><ChangeAnalysis {idproject} /></Route
    >
{/if}
